import React from 'react'
import { useTranslation } from 'next-i18next'

const WhyUs = () => {
  const { t } = useTranslation()
  
  const whyUsCards = [
    {
      id: 1,
      title: t("about-us-page.why-us-card-1-title"),
      items: [
        t("about-us-page.why-us-card-1-item-1"),
        t("about-us-page.why-us-card-1-item-2"),
        t("about-us-page.why-us-card-1-item-3"),
        t("about-us-page.why-us-card-1-item-4"),
        t("about-us-page.why-us-card-1-item-5"),
        t("about-us-page.why-us-card-1-item-6"),
        t("about-us-page.why-us-card-1-item-7"),
        t("about-us-page.why-us-card-1-item-8"),
        t("about-us-page.why-us-card-1-item-9")
      ]
    },
    {
      id: 2,
      title: t("about-us-page.why-us-card-2-title"),
      items: [
        t("about-us-page.why-us-card-2-item-1"),
        t("about-us-page.why-us-card-2-item-2"),
        t("about-us-page.why-us-card-2-item-3"),
        t("about-us-page.why-us-card-2-item-4"),
        t("about-us-page.why-us-card-2-item-5"),
        t("about-us-page.why-us-card-2-item-6"),
        t("about-us-page.why-us-card-2-item-7"),
        t("about-us-page.why-us-card-2-item-8"),
        t("about-us-page.why-us-card-2-item-9")
      ]
    },
    {
      id: 3,
      title: t("about-us-page.why-us-card-3-title"),
      items: [
        t("about-us-page.why-us-card-3-item-1"),
        t("about-us-page.why-us-card-3-item-2"),
        t("about-us-page.why-us-card-3-item-3"),
        t("about-us-page.why-us-card-3-item-4"),
        t("about-us-page.why-us-card-3-item-5")
      ]
    },
    {
      id: 4,
      title: t("about-us-page.why-us-card-4-title"),
      items: [
        t("about-us-page.why-us-card-4-item-1"),
        t("about-us-page.why-us-card-4-item-2"),
        t("about-us-page.why-us-card-4-item-3"),
        t("about-us-page.why-us-card-4-item-4"),
        t("about-us-page.why-us-card-4-item-5"),
        t("about-us-page.why-us-card-4-item-6"),
        t("about-us-page.why-us-card-4-item-7"),
        t("about-us-page.why-us-card-4-item-8")
      ]
    }
  ];

  return (
    <div className='bg-white max-w-[90%] md:pb-[200px] pb-[100px] pt-[40px] md:pt-[0px] mx-auto'>
      <div className="flex flex-row w-full justify-center gap-6 lg:gap-12  lg:mb-[100px] mb-[32px]">
        <div className="flex flex-col">
          <h2 className="text-[32px] md:text-[48px] lg:text-[64px] xl:text-[80px] font-[500] leading-tight flex flex-row items-center justify-center gap-[10px]">
            <span className="text-main-pink">{t("about-us-page.why-us-title-1")}</span>
            <span className="text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884]">{t("about-us-page.why-us-title-2")}</span>
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
        {whyUsCards.map((card) => (
          <div
            key={card.id}
            className="bg-[#F5F7F9] rounded-[52px] py-[40px] px-[24px] flex flex-col gap-[12px]"
          >
            <h3 className="text-[20px] md:text-[24px] font-[600] text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884] leading-tight ml-[15px]">
              {card.title}
            </h3>
            <ul className="flex flex-col">
              {card.items.map((item, index) => (
                <li
                  key={index}
                  className="text-[16px] lg:text-[20px] font-[400] text-[#8B8B8B] leading-relaxed flex items-start gap-3 "
                >
                  <span className="text-[#8B8B8B] flex-shrink-0">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  )
}

export default WhyUs
